import { Component, OnInit, ViewChild } from '@angular/core';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError, map, mergeMap } from 'rxjs/operators';
import { Observable, Subject, of } from 'rxjs';
import { ToastService } from '../../../shared/toast.service';
import { GlobalSearchResult } from './global-search-result.model';
import { SearchResult } from '../../../views/program-work/search-result.model';
import { SearchRequest } from '../../../views/program-work/search-request.model';
import { Rail360ViewService } from '../../../views/rail360view/rail360-view.service';
import { Router } from '@angular/router';
import { SharedModule } from '../../../shared/shared.module';


@Component({
	standalone: true,
	selector: 'global-search',
	templateUrl: 'global-search.component.html',
	imports: [SharedModule],
})
export class GlobalSearchComponent implements  OnInit  {
	@ViewChild('inputField') inputField;
	public results$: Observable<GlobalSearchResult[]>;
	public results$Loading: boolean;
	public searchTerm$ = new Subject<string>();
	public displayInput = false;
	private searchRequest: SearchRequest = new SearchRequest();

	constructor(
		private rail360ViewService: Rail360ViewService,
		private toastr: ToastService,
		private router: Router
	) { }

	ngOnInit() {
		this.search();
		this.displayInput = false;
	}

	public itemSelected(item: GlobalSearchResult) {
		if (item) {
			if (item.type === 'Lease') {
				alert('360View for ' + item.type + ' has not been created yet.');
			} else if (item.type === 'Customer') {
				var doesCustomerNameHaveForwardSlash = item.name.includes("/");
				var url = '';
				if (doesCustomerNameHaveForwardSlash) {
					var fixedCustomerName = item.name.replace(/[#/]/g, "");
					url = '/360view/' + item.type.toLowerCase() + '/' + item.id + '/' + fixedCustomerName;
				} else {
					url = '/360view/' + item.type.toLowerCase() + '/' + item.id + '/' + item.name;
				}
				this.router.navigate([url]);
			} else {
				const url = '/360view/' + item.type.toLowerCase() + '/' + item.id + '/' + item.name;
				this.router.navigate([url]);
			}
		}
	}

	public search() {
	    this.results$ = this.searchTerm$.asObservable().pipe(
		// this.results$ = of([]);
	    // this.searchTerm$.asObservable().pipe(
			debounceTime(500),
			distinctUntilChanged(),
		 	tap(() => this.results$Loading = true),
		// 	mergeMap<string, Observable<SearchResult>>(term => {
		// 		if (!term || term.length === 0) {
		// 			this.results$Loading = false;
		// 			return of({ facets: [], results: [], count: 0 } as SearchResult);
		// 		}
		// 		return this.rail360ViewService.search(this.searchRequest);
		// 	}))
		// 	.subscribe(result => {
		// 		this.results$ = result.map(result => new GlobalSearchResult(result.document.type, result.document.recordId, result.document.name)))
		// 		this.results$Loading = false;
		// 	}
		// , error => {
		// 	this.toastr.error(error, '360 Search Error');
		// 	this.results$Loading = false;
		// });
			switchMap(term => {
				if (!term || term.length === 0) {
					this.results$Loading = false;
					return of([]);
				}
				this.searchRequest.searchText = term;
				return this.rail360ViewService.search(this.searchRequest).pipe(
					catchError((error) => of(this.toastr.error(error, '360 Search Error'))),
					tap(() => this.results$Loading = false),
					map((sr: SearchResult) => 
						sr.results.map(result => new GlobalSearchResult(result.document.type, result.document.recordId, result.document.name)))
				)
			})
		);
	}

	public setFocus() {
		this.displayInput = true;
		setTimeout(() => {
			this.inputField.focus();
		},
		100);
	}

	public hideInput() {
		this.displayInput = false;
	}
}
